import React from 'react';
import intl from 'react-intl-universal';
import { CONSENT_TYPES } from 'src/constants/constants';

export const ConsentPage = ({
  pageHTML,
  togleConsent,
  accepted,
  acceptable,
  setCurrentPageRead,
  pageIndex,
  gdpcAccepted,
  showGDPCAccepted,
}) => {
  function getpageHTML(pageHTML) {
    return { __html: pageHTML };
  }
  const isMounted = React.useRef(false);

  React.useEffect(() => {
    if (isMounted.current) {
      const el = document.querySelector('.consent-inner-content');
      if (el.offsetHeight + el.scrollTop > el.scrollHeight - 20) {
        setCurrentPageRead(pageIndex);
      }
    } else {
      isMounted.current = true;
    }
  }, [pageIndex, setCurrentPageRead]);
  return (
    <React.Fragment>
      <div className="consent-page">
        <div className="consent-inner-content">
          <div className="consent-content" dangerouslySetInnerHTML={getpageHTML(pageHTML)} />
        </div>
        <div className={showGDPCAccepted ? 'consent-accept-bar-with-GDPC' : 'consent-accept-bar'}>
          <label className="checkbox">
            <input
              type="checkbox"
              name="corporateClient"
              disabled={!acceptable}
              checked={accepted}
              onChange={e => togleConsent(e, CONSENT_TYPES.OTHER)}
            />
            &nbsp;{intl.get('consent.accept')}
          </label>
          {showGDPCAccepted && (
            <div className="checkbox-GDPC">
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="corporateGDPCClient"
                  disabled={!acceptable}
                  checked={gdpcAccepted}
                  onChange={e => togleConsent(e, CONSENT_TYPES.GDPC)}
                />
                &nbsp;{intl.get('consent.gdpcTitle')}
              </label>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ConsentPage;
